module.exports = __webpack_public_path__ + "static/media/24893453091_d577950bc1_o-1-1.96d23860.jpg";